import { gql } from '@apollo/client';
export const TUITION_CALCULATION_FIELDS = gql `
  fragment TuitionCalculationFields on TuitionCalculation {
    id
    paymentRequestId
    clientId
    createdById
    updatedById
    lineItems
    totalTuitionAndFees
    totalNonReimbursableFees
    totalCreditsTuition
    subtotalAfterCredits
    totalGrantsScholarships
    totalRoomAndBoard
    totalCreditsHousing
    roomAndBoardAfterCredits
    reimbursableTuition
    notes
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
    updatedBy {
      id
      firstName
      lastName
    }
  }
`;
export const GET_TUITION_CALCULATION = gql `
  ${TUITION_CALCULATION_FIELDS}
  query GET_TUITION_CALCULATION($paymentRequestId: Int!) {
    tuitionCalculation(paymentRequestId: $paymentRequestId) {
      ...TuitionCalculationFields
    }
  }
`;
export const SAVE_TUITION_CALCULATION = gql `
  ${TUITION_CALCULATION_FIELDS}
  mutation SAVE_TUITION_CALCULATION($input: SaveTuitionCalculationInput!) {
    saveTuitionCalculation(input: $input) {
      success
      tuitionCalculation {
        ...TuitionCalculationFields
      }
      messages {
        value
        type
      }
    }
  }
`;
export const DELETE_TUITION_CALCULATION = gql `
  mutation DELETE_TUITION_CALCULATION($id: Int!) {
    deleteTuitionCalculation(id: $id)
  }
`;
